(function (window, document) {
    var DEFAULTS = {
        direction: 'up',
        toggleTag: 'button',
        toggleContent: '',
        toggleClass: '',
        menuClass: ''
    };

    var render = function (targetId, items, config) {
        var target = document.getElementById(targetId);
        if (!target) return null;

        var dropdown = target;
        dropdown.id = targetId;
        dropdown.classList.add('dropdown');
        dropdown.classList.add(DEFAULTS.direction === 'down' ? 'dropdown-down' : 'dropdown-up');

        if (items) {
            dropdown.innerHTML = '';
        }

        var appendItems = Array.isArray(items) ? items : [];
        config = config || {};

        var direction = config.direction || DEFAULTS.direction;
        if (direction === 'down') {
            dropdown.classList.remove('dropdown-up');
            dropdown.classList.add('dropdown-down');
        } else {
            dropdown.classList.remove('dropdown-down');
            dropdown.classList.add('dropdown-up');
        }

        var existingToggle = dropdown.querySelector(":scope > a, :scope > button");

        var toggleTag = (config.toggleTag || DEFAULTS.toggleTag).toLowerCase();
        var toggle = existingToggle ? existingToggle : document.createElement(toggleTag === 'a' ? 'a' : 'button');
        toggle.className = 'dropdown-toggle';
        if (config.toggleClass) {
            toggle.className += ' ' + config.toggleClass;
        }
        toggle.setAttribute('data-dropdown-toggle', '');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-haspopup', 'true');
        toggle.setAttribute('aria-controls', targetId + '-menu');
        toggle.id = targetId + '-toggle';
        if (toggleTag === 'a') {
            toggle.href = config.toggleHref || '#';
            toggle.setAttribute('role', 'button');
        } else {
            toggle.type = 'button';
        }

        if (!existingToggle) {
            toggle.innerHTML = config.toggleContent || DEFAULTS.toggleContent;
        }

        var existingMenu = dropdown.querySelector(":scope > ul");

        var menu = existingMenu ? existingMenu : document.createElement('ul');
        menu.id = targetId + '-menu';
        menu.className = 'dropdown-menu';
        if (config.menuClass) {
            menu.className += ' ' + config.menuClass;
        }
        menu.setAttribute('data-dropdown-menu', '');
        menu.setAttribute('role', 'list');

        appendItems.forEach(function (item) {
            if (!item || !item.label) return;

            var hasUrl = !!item.url;
            var element = document.createElement(hasUrl ? 'a' : 'span');
            element.className = 'dropdown-link';
            if (!hasUrl) {
                element.className += ' dropdown-link-static';
            }
            if (item.selected) {
                element.className += ' is-selected';
            }
            if (config.dataAttrName) {
                element.setAttribute('data-' + config.dataAttrName, item.value);
            }

            if (hasUrl) {
                element.href = item.url;
                if (item.newTab) {
                    element.target = '_blank';
                    element.rel = 'noopener';
                }
            }

            if (item.imageSrc) {
                var img = document.createElement('img');
                img.src = item.imageSrc;
                img.loading = 'lazy';
                img.alt = item.imageAlt || item.label;
                if (item.imageWidth) {
                    img.width = item.imageWidth;
                }
                if (item.imageClass) {
                    img.className = item.imageClass;
                }
                element.appendChild(img);
            }

            element.appendChild(document.createTextNode(item.label));

            var listItem = document.createElement('li');
            listItem.className = 'dropdown-item';
            listItem.appendChild(element);
            menu.appendChild(listItem);
        });

        // hydrate existing items
        if (existingMenu) {
            var existingMenuItems = dropdown.querySelectorAll("li");
            existingMenuItems.forEach(function (listItem) {
                listItem.className = 'dropdown-item';

                var element = listItem.querySelector("a,button");
                if (element) {
                    element.className = 'dropdown-link';
                }
            });
        }

        if (!existingToggle) {
            dropdown.appendChild(toggle);
        }

        if (!existingMenu) {
            dropdown.appendChild(menu);
        }

        var close = function () {
            dropdown.classList.remove('is-open');
            toggle.setAttribute('aria-expanded', 'false');
            document.removeEventListener('click', handleDocumentClick);
            document.removeEventListener('keyup', handleEscape);
        };

        var handleDocumentClick = function (event) {
            if (!dropdown.contains(event.target)) {
                close();
            }
        };

        var handleEscape = function (event) {
            if (event.key === 'Escape' || event.key === 'Esc') {
                close();
                toggle.focus();
            }
        };

        var handleToggle = function (event) {
            if (toggleTag === 'a') {
                event.preventDefault();
            }
            var isOpen = dropdown.classList.contains('is-open');
            if (isOpen) {
                close();
                return;
            }

            dropdown.classList.add('is-open');
            toggle.setAttribute('aria-expanded', 'true');
            document.addEventListener('click', handleDocumentClick);
            document.addEventListener('keyup', handleEscape);
        };

        var handleItemClick = function (event) {
            var targetItem = event.target.closest('.dropdown-link, .dropdown-link-static');
            if (!targetItem || !menu.contains(targetItem)) return;

            var dataValue = null;
            if (config.dataAttrName) {
                dataValue = targetItem.getAttribute('data-' + config.dataAttrName);
            }

            if (typeof config.callback === 'function') {
                config.callback(dataValue, targetItem, event, dropdown);
            }
        };

        toggle.addEventListener('click', handleToggle);
        toggle.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
                event.preventDefault();
                handleToggle(event);
            }
        });
        menu.addEventListener('click', handleItemClick);

        return dropdown;
    };

    window.Dropdown = {
        render: render
    };
})(window, document);
